import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RIEBase from 'components/core/editable/RIEBase';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import ProcessUtils from 'utils/ProcessUtils';
import ComboBoxHOC from 'components/core/ComboBoxHOC';
import Constants from 'utils/Constants';
import Flexbox from 'flexbox-react';


/**
 * Data location editable component for input dataset retrieval rules form
 */
export default class DataLocation extends RIEBase {
    static propTypes = {
        options: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.locationFocus = true;
        this.datastreamFocus = false;
    }

    keyDown = (event) => {
        if (event.keyCode === 13) { // Enter
            // prevent modal ok from firing before finish editing
            event.stopPropagation();

            //check to make sure neither input has dropdown open
            if (!this.dataLocationRef.current.state.menuIsOpen
                && !this.datastreamRef.current.state.menuIsOpen) {
                //if select menu is not open
                this.finishEditing();
            }
        } else if (event.keyCode === 27) { // Escape
            this.cancelEditing();
        }
    };

    onDataLocationChange = (selectObj) => {
        const newValue = _.cloneDeep(this.getNewValue());
        let site = null;
        let fac = null;
        if (selectObj) {
            if (typeof selectObj.value !== 'undefined') {
                const parts = selectObj.value.split(' ');
                site = parts[0];
                fac = parts[1] ? parts[1] : null;
            }
        }
        newValue.site = site;
        newValue.fac = fac;

        if (newValue.site !== null) {
            this.setState({ newValue });
        }

        this.locationFocus = true;
        this.datastreamFocus = false;
    };

    onDatastreamChange = (selectObj) => {
        const newValue = _.cloneDeep(this.getNewValue());
        newValue.datastream_name = selectObj ? selectObj.value : null;

        if (newValue.datastream_name !== null && typeof newValue.datastream_name !== 'undefined') {
            this.setState({ newValue });
        }

        this.locationFocus = false;
        this.datastreamFocus = true;
    };

    renderEditingComponent = () => {
        const value = this.getNewValue();
        this.dataLocationRef = React.createRef();
        this.datastreamRef = React.createRef();

        let locationString = value.site;
        locationString += value.fac ? ` ${value.fac}` : '';
        const dataLocation = Constants.convertValueToSelectValue(locationString, 'dataLocation');
        const datastream = Constants.convertValueToSelectValue(value.datastream_name);

        return (
            <Flexbox
                flexDirection="column" className={`data-location-input ${this.makeClassString()}`}
                {...this.props.editProps}
            >
                <Flexbox flexDirection="column" width="250px" padding="3px">
                    <InfoBoxLabel label="Datastream Location"/>
                    <ComboBoxHOC
                        ref={this.dataLocationRef}
                        value={dataLocation}
                        options={this.props.options.data_locations}
                        onChange={this.onDataLocationChange}
                        onBlur={this.elementBlur}
                        clearable={false}
                        autoFocus={this.locationFocus}
                    />
                </Flexbox>
                <Flexbox flexDirection="column" width="250px" padding="3px">
                    <InfoBoxLabel label="Datastream"/>
                    <ComboBoxHOC
                        creatable
                        ref={this.datastreamRef}
                        value={datastream}
                        options={this.props.options.datastreams}
                        onChange={this.onDatastreamChange}
                        onBlur={this.elementBlur}
                        clearable={false}
                        autoFocus={this.datastreamFocus}
                    />
                </Flexbox>
            </Flexbox>
        );
    };

    renderReadComponent = () => {
        const value = this.getNewValue();

        const dataLocation = ProcessUtils.getLocationDisplayText(value, 'dataLocation');
        // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
        // onFocus={this.startEditing}
        return (
            <span
                tabIndex="0"
                className={this.makeClassString()}
                onClick={this.startEditing}
                {...this.props.defaultProps}
            >
                {dataLocation} <i className="fa fa-arrow-right" /> {value.datastream_name}
            </span>
        );
    };

}



// WEBPACK FOOTER //
// ./src/components/core/editable/DataLocation.js